<template>
  <div :class="classCustom">
    <slot name="header">
    </slot>
    <slot name="view">
      <!-- sub_header -->
      <!-- view for list page -->
      <slot name="subHeaderExtend">
      </slot>
      <slot name="subHeader">
      </slot>
      <slot name="body">
      </slot>
      <!-- view for detail page -->
      <slot name="detail">
      </slot>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'list-template',
  props: ['classCustom']
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/common/list.vue